export default __webpack_public_path__ + "static/media/system.c843c1c1.svg";